import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidenavComponent } from '../../shared/components/sidenav/sidenav.component';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { Store } from '@ngxs/store';
import { AppSelectors } from '../../store/app/app.selectors';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SetUpTutorialModalComponent } from '../../shared/components/modals/set-up-tutorial-modal/set-up-tutorial-modal.component';
import { BusinessStatusBlockOverlayComponent } from '../../shared/components/business-status-block-overlay/business-status-block-overlay.component';
import { BusinessStatus } from '../../_interfaces/business.interface';
import { SubscriptionPaymentComponent } from '../../shared/components/subscription-payment/subscription-payment.component';
import { BetaRegistrationBlockOverlayComponent } from '../../shared/components/beta-registration-block-overlay/beta-registration-block-overlay.component';

@Component({
  selector: 'app-management',
  imports: [
    RouterOutlet,
    SidenavComponent,
    HeaderComponent,
    BusinessStatusBlockOverlayComponent,
    SubscriptionPaymentComponent,
    BetaRegistrationBlockOverlayComponent,
  ],
  templateUrl: './management-wrapper.component.html',
})
export class ManagementWrapperComponent implements OnInit, OnDestroy {
  readonly modalService = inject(NgbModal);
  private readonly store = inject(Store);

  readonly userProfile$ = this.store.select(AppSelectors.userDetails);
  readonly subscriptions = new Subscription();
  protected readonly BusinessStatus = BusinessStatus;
  private modalTriggered: boolean = false;
  businessStatus!: BusinessStatus;

  ngOnInit() {
    this.subscriptions.add(
      this.userProfile$.subscribe({
        next: (profile) => {
          if (profile) {
            this.businessStatus = profile.biz.status;
            if (
              !profile.onboarding_completed &&
              !this.modalTriggered &&
              this.businessStatus === this.BusinessStatus.Active
            ) {
              this.displayOnboardingModal();
            }
          }
        },
      }),
    );
  }

  displayOnboardingModal() {
    this.modalTriggered = true; // Check if modal has been triggered
    this.modalService.open(SetUpTutorialModalComponent, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
